import { ModelSelectionCard } from "./ModelSelectionCard";

export function AssistantAdminPage(): React.ReactElement {
  return (
    <div data-testid="assistant-admin-page" className="space-y-6">
      <ModelSelectionCard />
    </div>
  );
}
